import React from 'react';
import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { LOGISTICA_PRODUCTOS_CON_LOTE, VALIDAR_STOCK, VENTA_PRECIO_UNITARIO_INCLUYE_IGV, CONVERSION_MEDIDA, VENTA_DECIMAL, SERIE_POR_PRODUCTO } from '../../../../common/types/parametroType'
import global from '../../../../common/utility/global';
import auth from '../../../../common/utility/auth';
import { PRECIO_VENTA } from '../../../../common/types/tipoListaPrecioType';

const { Option } = Select;

export default function Productos(props) {
    const mostrarLote = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    const precioUnitarioInclIGV = auth.user().parametros.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
    const conversionMedida = auth.user().parametros.filter(m => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
    const precioVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 30 : 0,
                        fixed: 'left',
                        render: (value, row, index) => (

                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Buscar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue, index)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 85,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrcodigo[${row.identifier}]`, {
                                        initialValue: value
                                    })(

                                        row.isItemLibre ?
                                            <Input
                                                placeholder="Codigo"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, "arrcodigo", e.target.value, 0, index)}
                                            />
                                            : <span>{value}</span>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: mostrarLote === false ? '' : 'Lote',
                        dataIndex: 'numeroLote',
                        key: 'numeroLote',
                        width: mostrarLote === false ? 0 : 100,
                        render: (value, row) => {
                            return (
                                <div>
                                    {props.onGetFieldDecorator(`arrNumeroLote[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            disabled={true}
                                            title={props.onGetFieldValue(`arrNumeroLote[${row.identifier}]`)}
                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 90 : 0,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'}
                                    onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 120,
                        render: (value, row) => {
                            return (
                                <div
                                    onClick={() => props.onEditarNombreProducto(row, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrNombre[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}
                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 120,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridUnidadMedida[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        row.isItemLibre ?
                                            <Select showSearch labelInValue
                                                placeholder={"Seleccione Tipo Unidad de Medida"}
                                                optionFilterProp="children"
                                                onChange={(option) => { props.onCalculateDetail(row, "arridUnidadMedida", option.key, 0, index); }}

                                            >
                                                {props.unidadesMedida.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                ))}
                                            </Select> :
                                            conversionMedida && row.itemConversion.length > 0 && props.onGetFieldValue('idTipoPrecio')[0].idTipoListaPrecio == PRECIO_VENTA ?
                                                <Select showSearch labelInValue
                                                    placeholder={"Seleccione Tipo Unidad de Medida"}
                                                    optionFilterProp="children"
                                                    onChange={(option) => { props.handleSelectConversion(row, option.key, index, row.identifier); }}
                                                    disabled={row.idTipoProducto == 2 ? true : false}
                                                >
                                                    {row.itemConversion.map(item => (
                                                        <Option key={item.idUnidadMedida} value={item.idUnidadMedida}>{item.unidadMedida}</Option>
                                                    ))}
                                                </Select>
                                                : <span> {value} </span>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, "arridImpuesto", option.key, 0, index); }}
                                        >
                                            {props.tipoAfectacion.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    // {
                    //     dataIndex: 'isc',
                    //     key: 'isc',
                    //     align: 'center',
                    //     width: 0,
                    //     render: (value, row) => {
                    //         return (
                    //             <div>
                    //                 {props.onGetFieldDecorator(`arrIsc[${row.identifier}]`, {
                    //                     initialValue: parseFloat(value).toFixed(2)
                    //                 })(
                    //                     <Input />
                    //                 )}
                    //             </div>
                    //         );
                    //     }
                    // },
                    {
                        title: (precioUnitarioInclIGV ? 'Precio Unitario' : 'Valor Unitario'),
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(precioVenta),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(precioVenta == 2 ? FORMAT_2DECIMALS : FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: row.flagAfecto ? true : false,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: ""
                                        }
                                        ]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.precioUnitarioDisabled}
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Tooltip title={validarStock ? (row.stock ? `Stock Disponible: ${row.stock.toFixed(2)}` : '') : ''}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                            initialValue: parseFloat(value).toFixed(cantidadVenta),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(cantidadVenta == 2 ? FORMAT_2DECIMALS : FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                },
                                                {
                                                    required: true,
                                                    pattern: new RegExp(GREATER_THAN_ZERO),
                                                    message: ""
                                                }
                                            ]
                                        })(
                                            <Input
                                                disabled={row.flagAplicarSerie ? true : false}
                                                onKeyPress={global.onKeyPressDecimals}
                                                placeholder="Cantidad"
                                                autoComplete="off"
                                                className="text-right"
                                                onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3, index)}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },
                    {
                        title: 'Total Detalle',
                        dataIndex: 'totalDetalle',
                        key: 'totalDetalle',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrTotalDetalle[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Porcentaje Descuento',
                        dataIndex: 'porcentajeDescuento',
                        key: 'porcentajeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPorcentajeDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="% Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPorcentajeDescuento", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Importe Descuento',
                        dataIndex: 'importeDescuento',
                        key: 'importeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrImporteDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="Imp. Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrImporteDescuento", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.totalDisabled}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2, index)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                ]}
            />
        </div>
    );
}